<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" style="border-radius: 5px;" v-if="isHavePermission('eleContract:create')"
              @click="showDialog">新建电子合同流程
      </Button>
      <Button type="primary" @click="batchDownload" icon="md-download"
              v-if="isHavePermission('eleContract:batchDownload')"
              :style="isHavePermission('eleContract:create') ? 'margin-left: 10px;border-radius: 5px;':''">合同批量下载
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="isHavePermission('eleContract:batchDownload') ? 'margin-left: 10px' :''">刷新
      </vxe-button>
      <div class="search-filter" v-show="tabVal === 'ele'">
        <Poptip placement="bottom-end" width="680" v-model="searchVisibleEle">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormDataEle" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同编号" field="contractNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.contractNum"
                      placeholder="输入合同编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同名称" field="contractName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.contractName"
                      placeholder="输入合同名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同类型" field="contractTypeList" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormDataEle.contractTypeList"
                      :options="concatType()"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约方" field="secondPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSecondPartyNameEle"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameEleOptions')"
                      :remote-method="(file) =>remoteMethod(file,'secondPartyNameEleOptions', 'eleContract', 'queryPartyName', 2)"
                      placeholder="输入签约方"
                  >
                    <Option
                        v-for="option in secondPartyNameEleOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="手机号" field="partyPhone" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.partyPhone"
                      placeholder="输入手机号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约日期" field="partyTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormDataEle.partyTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同有效期至" field="passTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormDataEle.passTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运日期" field="beginDate" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormDataEle.beginDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运地" field="beginPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.beginPlace"
                      placeholder="输入起运地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达地" field="endPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormDataEle.endPlace"
                      placeholder="输入到达地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesMan" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesManEle"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManEleOptions')"
                      :remote-method="(file) =>remoteMethod(file,'salesManEleOptions', 'eleContract', 'queryContractFadadaKeyword', 3)"
                      placeholder="输入业务员"
                  >
                    <Option v-for="option in salesManEleOptions" :value="option.id" :key="option.text">{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUserEle"
                      multiple
                      clearable
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserEleOptions')"
                      :remote-method="(file) =>remoteMethod(file,'createUserEleOptions', 'eleContract', 'queryContractFadadaKeyword', 4)"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserEleOptions" :value="option.id" :key="option.text">{{
                        option.text
                      }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormDataEle.createTime"
                      :options="timeOptions"
                      placeholder="创建时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKeyEle" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="resetEle" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="openEle"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="openEle"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChangeEle"
                  @on-clear="handleClearEle"
                  @on-ok="handleOkEle"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <div class="search-filter" v-show="tabVal === 'carriage'">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同编号" field="contractNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractNum"
                      placeholder="输入合同编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同名称" field="contractName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractName"
                      placeholder="输入合同名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同类型" field="contractTypeList" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.contractTypeList"
                      :options="concatType()"
                      placeholder="全部"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="发起方" field="firstPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFirstPartyName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'firstPartyNameOptions')"
                      :remote-method="(file) =>remoteMethod(file,'firstPartyNameOptions', 'eleContract', 'queryContractFadadaKeyword', 1)"
                      placeholder="输入发起方"
                  >
                    <Option
                        v-for="option in firstPartyNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约方" field="secondPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSecondPartyName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameOptions')"
                      :remote-method="(file) =>remoteMethod(file,'secondPartyNameOptions', 'eleContract', 'queryContractFadadaKeyword', 2)"
                      placeholder="输入签约方"
                  >
                    <Option
                        v-for="option in secondPartyNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="手机号" field="secondPartyPhone" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.secondPartyPhone"
                      placeholder="输入手机号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约日期" field="secondPartyTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.secondPartyTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="carShipNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.carShipNum"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运日期" field="goodsBeginDate" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.goodsBeginDate"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运地" field="beginPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.beginPlace"
                      placeholder="输入起运地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="到达地" field="endPlace" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.endPlace"
                      placeholder="输入到达地"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesMan" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesMan"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
                      :remote-method="(file) =>remoteMethod(file,'salesManOptions', 'eleContract', 'queryContractFadadaKeyword', 3)"
                      placeholder="输入业务员"
                  >
                    <Option v-for="option in salesManOptions" :value="option.id" :key="option.text">{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      clearable
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserOptions')"
                      :remote-method="(file) =>remoteMethod(file,'createUserOptions', 'eleContract', 'queryContractFadadaKeyword', 4)"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserOptions" :value="option.id" :key="option.text">{{
                        option.text
                      }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="创建时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
      <div class="search-filter" v-show="tabVal === 'matching'">
        <Poptip placement="bottom-end" width="680" v-model="searchVisibleMathing">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="发起方" field="firstPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchFirstPartyNameMatching"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'firstPartyNameOptionsMatching')"
                      :remote-method="(file) =>remoteMethod(file,'firstPartyNameOptionsMatching', 'eleContract', 'queryContractFadadaKeyword', 1)"
                      placeholder="输入发起方"
                  >
                    <Option
                        v-for="option in firstPartyNameOptionsMatching"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约方" field="secondPartyName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSecondPartyNameMatching"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'secondPartyNameOptionsMatching')"
                      :remote-method="(file) =>remoteMethod(file,'secondPartyNameOptionsMatching', 'eleContract', 'queryContractFadadaKeyword', 2)"
                      placeholder="输入签约方"
                  >
                    <Option
                        v-for="option in secondPartyNameOptionsMatching"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button type="primary" icon="ios-search" @click="getSearchListKeyMatching(null)"
                          style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="resetMatching" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
      </div>
    </div>
    <Tabs :value="tabVal" @on-click="changeTab">
      <TabPane label="自定义电子合同" name="ele">
        <div class="list-box common-shadow clearfix">
          <vxe-table
              ref="eleTable"
              class="table-style"
              highlight-hover-row
              show-footer
              stripe
              align="center"
              border="none"
              show-overflow
              height="560"
              :loading="loading"
              :data="eleData"
              :remote-filter="true"
              @filter-change="filterChangeMethodEle"
              @checkbox-all="selectAllEventEle"
              @checkbox-change="selectChangeEventEle"
              resizable
          >
            <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
            <vxe-table-column title="操作" width="90">
              <template slot-scope="{ row }">
                <Dropdown trigger="click" style="margin-left: 10px; cursor: pointer" transfer>
                  <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
                  <DropdownMenu slot="list" style="left: 70px">
                    <div style="display: flex; flex-direction: column">
                      <!--                      <Button class="button-gengduo" @click="commitUpdate(row.id,row.flowId)"-->
                      <!--                              v-if="isHavePermission('eleContract:update')">-->
                      <!--                        编辑-->
                      <!--                      </Button>-->
                      <!--                      <Button class="button-gengduo"-->
                      <!--                              v-if="isHavePermission('eleContract:sign')"-->
                      <!--                              @click="commitSign(row)">签署-->
                      <!--                      </Button>-->
                      <!--                      <Button class="button-gengduo"-->
                      <!--                              v-if="isHavePermission('eleContract:refuse')"-->
                      <!--                              @click="commitRefuse(row.id)">拒绝-->
                      <!--                      </Button>-->
                      <Button class="button-gengduo"
                              v-if="isHavePermission('eleContract:download') && row.fadadaState === 2"
                              @click="downloadContract(row)">下载
                      </Button>
                      <Button class="button-gengduo"
                              v-if="row.fadadaState === 1 && row.isMsg && isHavePermission('eleContract:send')"
                              @click="sendContractUrlMsg(row.id)">催客户签署
                      </Button>
                      <Button class="button-gengduo"
                              v-if="row.fadadaState === 1 && isHavePermission('eleContract:cancel')"
                              @click="commitCancel(row.id)">撤回
                      </Button>
                      <Button class="button-gengduo"
                              v-if="isHavePermission('eleContract:changeType')"
                              @click="changeType(row)">修改合同类型
                      </Button>
                      <Button class="button-gengduo" @click="commitDelete(row.id)"
                              v-if="isHavePermission('eleContract:delete') && row.fadadaState === 2 || row.fadadaState === 3 || row.fadadaState === 4"
                              style="color: #ed4014">删除
                      </Button>
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractNum" title="合同编号" width="150">
              <template slot-scope="{ row }">
                <a v-if="isHavePermission('eleContract:view')" @click="viewContract(row)">{{ row.contractNum }}</a>
                <span v-else>{{ row.contractNum }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
            <vxe-table-column field="fadadaState" title="合同状态"
                              :filters="[{label: '待签署', value: 1}, {label: '已签署', value: 2},{label: '已撤回', value: 3}, {label: '已拒绝', value: 4}]"
                              :filter-multiple="false" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.fadadaState | fadadaState }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractType" title="合同类型" width="150">
              <template slot-scope="{ row }">
                <span>{{ elecontractType(row) }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="signType" title="签约方式" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.signType | signType }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="partyNameStr" title="签约方" width="400" show-overflow="ellipsis">
              <template slot-scope="{ row }">
                <Poptip trigger="hover" placement="left" transfer>
                  <span>{{ row.partyNameStr }}</span>
                  <template slot="title"></template>
                  <template slot="content">
                    <div style="padding: 18px 0;box-sizing: border-box;">
                      <div v-for="(item,index) in row.ordContractFadadaExpands" :key="index" style="">
                        <div class="signDiv">
                          <div :class="item.state === 2 || item.state === 4 ? 'signState grey' : 'signState'">
                            {{ item.state === 2 ? '已签' : item.state === 4 ? '已拒绝' : '待签' }}
                          </div>
                          <div class="signContent">
                            <span>{{ item.partyName }}</span>
                            <span>{{ item.partyPhone ? '手机：' + item.partyPhone : '' }}</span>
                          </div>
                        </div>
                        <div class="line" v-if="(index + 1) !== row.ordContractFadadaExpands.length"></div>
                      </div>
                    </div>
                  </template>
                </Poptip>
              </template>
            </vxe-table-column>
            <vxe-table-column field="partyTime" title="签约日期" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.effectiveTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="passTime" title="合同有效期至" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.passTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
            <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
            <vxe-table-column field="beginTime" title="起运日期" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.beginTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="salesMan" title="业务员" width="200"></vxe-table-column>
            <vxe-table-column field="flowNum" title="流程编号" width="130">
              <template slot-scope="{ row }">
                <span @click="openProcedureDetail(row.flowId, 2)" style="color: #2d8cf0; cursor: pointer">{{
                    row.flowNum
                  }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="createUser" title="创建人" width="150"></vxe-table-column>
            <vxe-table-column field="createTime" title="创建时间" width="150">
              <template slot-scope="{ row }">
                <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
          <vxe-pager
              background
              size="small"
              :current-page.sync="elePage.currentPage"
              :page-size.sync="elePage.pageSize"
              :total="elePage.totalResult"
              @page-change="changePageEle"
          ></vxe-pager>
        </div>
      </TabPane>
      <TabPane label="平台运输合同" name="carriage">
        <div class="list-box common-shadow clearfix">
          <vxe-table
              ref="xTable"
              class="table-style"
              highlight-hover-row
              show-footer
              stripe
              align="center"
              border="none"
              show-overflow
              max-height="560"
              :loading="loading"
              :data="tableData"
              :remote-filter="true"
              @filter-change="filterChangeMethod"
              @checkbox-all="selectAllEvent"
              @checkbox-change="selectChangeEvent"
          >
            <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
            <vxe-table-column title="操作" width="90">
              <template slot-scope="{ row }">
                <Dropdown trigger="click" style="margin-left: 10px; cursor: pointer" transfer>
                  <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
                  <DropdownMenu slot="list" style="left: 70px">
                    <div style="display: flex; flex-direction: column">
                      <Button class="button-gengduo" @click="commitUpdate(row.id,row.flowId)"
                              v-if="row.self === 1 && (row.firstState === 3 || row.secondState === 4) && isHavePermission('eleContract:update')">
                        编辑
                      </Button>
                      <Button class="button-gengduo"
                              v-if="((row.self === 1 && row.firstState === 1) || (row.self === 2 && row.secondState === 1) )&& isHavePermission('eleContract:sign')"
                              @click="commitSign(row)">签署
                      </Button>
                      <Button class="button-gengduo"
                              v-if="row.self === 2 && row.secondState === 1 && isHavePermission('eleContract:refuse')"
                              @click="commitRefuse(row.id)">拒绝
                      </Button>
                      <Button class="button-gengduo"
                              v-if="isHavePermission('eleContract:download') && row.firstState === 2 && row.secondState === 2"
                              @click="downloadContract(row)">下载
                      </Button>
                      <Button class="button-gengduo"
                              v-if="(row.self === 0 || row.self === 1) && row.firstState === 2 && row.secondState === 1 && (!row.msgCount || row.msgCount < 2) && isHavePermission('eleContract:send')"
                              @click="sendContractUrlMsg(row.id)">催客户签署
                      </Button>
                      <Button class="button-gengduo"
                              v-if="(row.self === 0 || row.self === 1) && row.firstState === 2 && row.secondState === 1 && isHavePermission('eleContract:cancel')"
                              @click="commitCancel(row.id)">撤回
                      </Button>
                      <Button class="button-gengduo" @click="commitDelete(row.id)"
                              v-if="row.self === 1 && (row.firstState === 1 || row.firstState === 3 || row.secondState === 4) && isHavePermission('eleContract:delete')"
                              style="color: #ed4014">删除
                      </Button>
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractNum" title="合同编号" width="150">
              <template slot-scope="{ row }">
                <a v-if="isHavePermission('eleContract:view')" @click="viewContract(row)">{{ row.contractNum }}</a>
                <span v-else>{{ row.contractNum }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
            <vxe-table-column field="state" title="合同状态"
                              :filters="[{label: '发起方待签署', value: 1}, {label: '签约方待签署', value: 2},{label: '发起方已撤回', value: 3}, {label: '签约方已拒绝', value: 4},{label: '已签署', value: 5}]"
                              :filter-multiple="false" width="150">
              <template slot-scope="{ row }">
                <span>{{ state(row) }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractType" title="合同类型" width="150">
              <template slot-scope="{ row }">
                <span>{{ elecontractType(row) }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="firstPartyName" title="发起方" width="200">
              <template slot-scope="{ row }">
                <span>{{ row.firstPartyName }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="secondPartyName" title="签约方" width="200"></vxe-table-column>
            <vxe-table-column field="secondPartyPhone" title="手机号" width="150"></vxe-table-column>
            <vxe-table-column field="secondPartyTime" title="签约日期" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.secondPartyTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <!--            <vxe-table-column field="passTime" title="合同有效期" width="150">-->
            <!--              <template slot-scope="{ row }">-->
            <!--                <span>{{ row.passTime | timeFormatDate }}</span>-->
            <!--              </template>-->
            <!--            </vxe-table-column>-->
            <vxe-table-column field="carShipNum" title="车船号" width="100"></vxe-table-column>
            <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
            <vxe-table-column field="beginTime" title="起运日期" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.beginTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="beginPlace" title="起运地" width="150"></vxe-table-column>
            <vxe-table-column field="endPlace" title="到达地" width="150"></vxe-table-column>
            <vxe-table-column field="salesMan" title="业务员" width="200"></vxe-table-column>
            <vxe-table-column field="flowNum" title="流程编号" width="130">
              <template slot-scope="{ row }">
                <span @click="openProcedureDetail(row.flowId, 2)" style="color: #2d8cf0; cursor: pointer">{{
                    row.flowNum
                  }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="createUser" title="创建人" width="150"></vxe-table-column>
            <vxe-table-column field="createTime" title="创建时间" width="150">
              <template slot-scope="{ row }">
                <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
          <vxe-pager
              background
              size="small"
              :current-page.sync="page.currentPage"
              :page-size.sync="page.pageSize"
              :total="page.totalResult"
              @page-change="changePage"
          ></vxe-pager>
        </div>
      </TabPane>
      <TabPane label="撮合订单电子合同" name="matching">
        <div class="list-box common-shadow clearfix">
          <vxe-table
              ref="xTable"
              class="table-style"
              highlight-hover-row
              show-footer
              stripe
              align="center"
              border="none"
              show-overflow
              max-height="560"
              :loading="loading"
              :data="matchingData"
              :remote-filter="true"
              @filter-change="filterChangeMethodMatching"
              @checkbox-all="selectAllEventMatching"
              @checkbox-change="selectChangeEventMatching"
          >
            <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
            <vxe-table-column field="contractNum" title="合同编号">
              <template slot-scope="{ row }">
                <a v-if="isHavePermission('eleContract:view') && (row.viewpdfUrl || row.docUrl)"
                   @click="viewContract(row)">{{ row.contractNum }}</a>
                <span v-else>{{ row.contractNum }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
            <vxe-table-column field="state" title="合同状态"
                              :filters="[{label: '待签署', value: 1}, {label: '已签署', value: 2}]"
                              :filter-multiple="false" width="150">
              <template slot-scope="{ row }">
                <span>{{ row.fadadaState | fadadaState }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="firstPartyName" title="发起方">
              <template slot-scope="{ row }">
                <span>{{ row.firstPartyName }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="secondPartyName" title="签约方"></vxe-table-column>
            <vxe-table-column field="secondPartyTime" title="签约日期">
              <template slot-scope="{ row }">
                <span>{{ row.secondPartyTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
            <vxe-table-column field="createTime" title="创建时间">
              <template slot-scope="{ row }">
                <span style="color: #a7adad">{{ row.createTime | timeFormatDate }}</span>
              </template>
            </vxe-table-column>
          </vxe-table>
          <vxe-pager
              background
              size="small"
              :current-page.sync="matchingPage.currentPage"
              :page-size.sync="matchingPage.pageSize"
              :total="matchingPage.totalResult"
              @page-change="changeMatchingPage"
          ></vxe-pager>
        </div>
      </TabPane>
    </Tabs>
    <!--    <vxe-modal class="proModal" v-model="isShowModal" title="新建电子合同" width="1120" height="950" position="center"-->
    <!--               resize @close="closeModal">-->
    <!--      <create-modal ref="eleModal" @close="close"></create-modal>-->
    <!--    </vxe-modal>-->
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center" @close="close"
               resize>
      <contract-detail ref="detailModal" @close="closeDetail"></contract-detail>
    </vxe-modal>
    <vxe-modal v-model="changeVisible" title="修改合同类型" width="500" height="200" @close="changeVisible = false" resize
               position="center" destroy-on-close>
      <change-contract-type ref="changeType" @afterChange="afterChange"
                            @close="changeVisible = false"></change-contract-type>
    </vxe-modal>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import $C from "@/consts";
import {SEARCH_TIME} from "@/filters/time";
import moment from "moment";
import getAuthOrization from "@/mixin/getAuthOrization";
import {postBlob, hideLoading, isEmpty, saveBlob, showLoading, blobToJson, showErrorContractData} from "@/utils/util";
import ContractDetail from "@/views/contracts/contractDetail";
import CreateModal from "@/views/contracts/CreateModal";
import auth from "@/utils/auth";
import openProcedureDetail from "@/mixin/viewOrderDetail";
import ChangeContractType from "@/views/contracts/ChangeContractType";

moment.locale("zh-CN");

export default {
  name: "EleContract",
  components: {ContractDetail, ChangeContractType},
  mixins: [getAuthOrization, openProcedureDetail],
  data() {
    let userInfoValue = {};
    if (auth.isLogin()) {
      userInfoValue = auth.getAuth();
    }
    return {
      userInfoValue,
      changeVisible: false,
      searchLoading: false,
      searchVisible: false,
      searchVisibleEle: false,
      searchVisibleMathing: false,
      open: false,
      openEle: false,
      timeOptions: SEARCH_TIME.options,
      loading: false,
      modalTitle: "",
      eleData: [],
      tableData: [],
      matchingData: [],
      searchFormData: {
        contractNum: null,
        contractName: null,
        contractTypeList: null,
        secondPartyPhone: null,
        secondPartyTime: null,
        carShipNum: null,
        goodsName: null,
        goodsBeginDate: null,
        createTime: null,
        state: null,
        beginPlace: null,
        endPlace: null
      },
      searchFormDataEle: {
        contractNum: null,
        contractName: null,
        contractTypeList: null,
        partyPhone: null,
        partyTime: null,
        carShipNum: null,
        goodsName: null,
        beginDate: null,
        createTime: null,
        state: null,
        beginPlace: null,
        endPlace: null,
        passTime: null
      },
      page: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      elePage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      matchingPage: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      isShowModal: false,
      valueType: [],
      contractListType: [],
      detailModal: false,
      searchFirstPartyNameMatching: [],
      firstPartyNameOptionsMatching: [],
      searchSecondPartyNameMatching: [],
      secondPartyNameOptionsMatching: [],
      searchFirstPartyName: [],
      firstPartyNameOptions: [],
      searchSecondPartyName: [],
      secondPartyNameOptions: [],
      searchSecondPartyNameEle: [],
      secondPartyNameEleOptions: [],
      searchSalesManEle: [],
      searchSalesMan: [],
      salesManOptions: [],
      searchCreateUser: [],
      createUserOptions: [],
      salesManEleOptions: [],
      searchCreateUserEle: [],
      createUserEleOptions: [],
      paramsObj: {
        page: 1,
        rows: 10,
      },
      paramsObjEle: {
        page: 1,
        rows: 10,
      },
      paramsMatchingObj: {
        page: 1,
        rows: 10,
      },
      eleRecords: [],
      matchingRecords: [],
      records: [],
      tabVal: 'ele'
    };
  },
  watch: {
    "searchFormData.secondPartyTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("secondPartyTime");
      },
    },
    "searchFormData.goodsBeginDate": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("goodsBeginDate");
      },
    },
    "searchFormData.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDate("createTime");
      },
    },
    "searchFormDataEle.partyTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDateEle("partyTime");
      },
    },
    "searchFormDataEle.beginDate": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDateEle("beginDate");
      },
    },
    "searchFormDataEle.createTime": {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        this.openRangeDateEle("createTime");
      },
    },
  },
  filters: {
    fadadaState(val) {
      if (val != null) {
        if (val === 1) {
          return "待签署";
        }
        if (val === 2) {
          return "已签署";
        }
        if (val === 3) {
          return "已撤回";
        }
        if (val === 4) {
          return "已拒绝";
        }
      }
    },
    signType(val) {
      if (val != null) {
        if (val === 1) {
          return "单方签署";
        }
        if (val === 2) {
          return "双方签署";
        }
        if (val === 3) {
          return "多方签署";
        }
      }
    },
    dataType(val) {
      if (val != null) {
        if (val === 1) {
          return "自定义模板";
        }
        if (val === 2) {
          return "平台运输模板";
        }
      }
    },
  },
  mounted() {
    this.$bus.$on("平台合同管理", () => {
      this.reset();
      this.resetEle();
      this.getSearchListKey();
      this.getSearchListKeyEle();
    });

    this.getDictByCode(41400, 'valueType');
    this.getDicData();
    this.getMatchingContractFadadaList(this.paramsMatchingObj);
    this.getContractFadadaTwoList(this.paramsObjEle);
    this.getContractFadadaList(this.paramsObj);
  },
  methods: {
    changeTab(e) {
      this.tabVal = e;
    },
    unique(arr, val) {
      let res = new Map();
      return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1))
    },
    concatType() {
      let arr = [];
      let concatArr = this.contractListType.concat(this.valueType);
      let repetArr = this.unique(concatArr, 'label');
      repetArr.map((i, index) => {
        this.valueType.map(j => {
          if (i.label === j.label) {
            arr.push({
              index: index,
              label: i.label,
              value: i.value + '#' + j.value
            })
          }
        })
      })
      arr.map(i => {
        let index = i.index;
        repetArr[index] = {
          label: i.label,
          value: i.value
        };
      })
      return repetArr;
    },
    commitUpdate(id, flowId) {
      this.isShowModal = true;
      this.$nextTick(() => {
        this.$refs.eleModal.setUpdate(id, flowId);
      })
    },
    commitRefuse(id) {
      this.$XModal.confirm("您确定要拒绝吗？").then((type) => {
        if (type === "confirm") {
          this.refuseContractFadada(id);
        }
      });
    },
    async refuseContractFadada(id) {
      let res = await $api.eleContract.request("refuseContractFadada", {
        id: id,
      });
      if (res.status === 1) {
        this.$Message.success("拒绝成功");
        this.refresh();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    commitSign(row) {
      if (row.dataType === 1) {
        this.getContractFadadaDetail(row);
      } else {
        this.signContractSecondPallet(row);
      }
    },
    async signContractSecondPallet(row) {
      showLoading();
      let res = await $api.eleContract.post("signContractSecondPallet", {
        contractId: row.id,
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("签署成功");
        this.refresh();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getContractFadadaDetail(row) {
      showLoading();
      let res = await $api.eleContract.post("getContractFadadaDetail", {
        id: row.id,
      });
      hideLoading();
      if (res.status === 1) {
        window.open(res.data.fadadaSignUrl);
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    state(row) {
      if (row.firstState === 2 && row.secondState === 2) {
        return '已签署';
      }
      if (row.secondState === 4) {
        return '签约方已拒绝';
      }
      if (row.firstState === 3) {
        return '发起方已撤回';
      }
      if (row.firstState === 2) {
        return '签约方待签署';
      }
      if (row.firstState === 1) {
        return '发起方待签署';
      }
      // if (row.firstState === 0) {
      //   return '待审核';
      // }
    },
    async batchDownload() {
      let records = this.tabVal === 'ele' ? this.eleRecords : this.records;
      if (records.length === 0) {
        this.$XModal.alert({
          message: '请选择至少一条合同信息',
          status: "error",
        });
        return
      }

      let fadadaStateFilter = this.tabVal === 'ele' ? records.filter(i => i.fadadaState !== 2) : records.filter(i => i.secondState !== 2)
      if (fadadaStateFilter.length > 0) {
        let errArr = fadadaStateFilter.map(i => {
          return {
            failArrayIndex: i.contractNum,
            failMsg: "状态不是已签署"
          }
        })
        showErrorContractData(errArr)
        return
      }
      let idList = [];
      records.map(i => {
        idList.push(i.id);
      })
      showLoading();
      let res = postBlob("/api/order/electricContract/downAttachFilesFadadaFile", {
        ids: idList
      });
      hideLoading();
      await saveBlob(".zip", res.data)
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    selectChangeEventEle({checked, row}) {
      if (checked) {
        this.eleRecords.push(row);
      } else {
        let key = this.eleRecords.indexOf(row);
        this.eleRecords.splice(key, 1);
      }
    },
    selectAllEventEle({checked, records}) {
      if (checked) {
        this.eleRecords = records;
      } else {
        this.eleRecords = [];
      }
    },
    selectChangeEventMatching({checked, row}) {
      if (checked) {
        this.matchingRecords.push(row);
      } else {
        let key = this.matchingRecords.indexOf(row);
        this.matchingRecords.splice(key, 1);
      }
    },
    selectAllEventMatching({checked, records}) {
      if (checked) {
        this.matchingRecords = records;
      } else {
        this.matchingRecords = [];
      }
    },
    closeDetail() {
      this.detailModal = false;
    },
    elecontractType(row) {
      let label = '';
      let val = row.contractType;
      if (row.dataType === 1) {
        this.valueType.map(i => {
          if (val === i.value) {
            label = i.label;
          }
        })
      } else {
        this.contractListType.map(i => {
          if (val === i.value) {
            label = i.label;
          }
        })
      }
      return label;
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    getDicData() {
      this.contractListType = [];
      $api.other.getContractType
          .GET({
            params: {
              page: 1,
              rows: 100
            }
          })
          .then(res => {
            res.data.forEach(item => {
              let obj = {
                label: item.dictText,
                value: parseInt(item.encoded)
              };
              this.contractListType.push(obj);
            });
          });
    },
    filterChangeMethodMatching({values}) {
      this.matchingPage.currentPage = 1;
      if (values.length > 0) {
        this.getSearchListKeyMatching(values[0]);
      } else {
        this.getSearchListKeyMatching();
      }
    },
    filterChangeMethodEle({values}) {
      this.elePage.currentPage = 1;
      if (values.length > 0) {
        this.searchFormDataEle.fadadaState = values[0];
      } else {
        this.searchFormDataEle.fadadaState = null;
      }
      this.getSearchListKeyEle()
    },
    filterChangeMethod({values}) {
      this.page.currentPage = 1;
      if (values.length > 0) {
        if (values[0] === 0) {
          this.searchFormData.firstState = 0;
          this.searchFormData.secondState = null;
        }
        if (values[0] === 1) {
          this.searchFormData.firstState = 1;
          this.searchFormData.secondState = null;
        }
        if (values[0] === 2) {
          this.searchFormData.firstState = 2;
          this.searchFormData.secondState = 1;
        }
        if (values[0] === 3) {
          this.searchFormData.firstState = 3;
          this.searchFormData.secondState = null;
        }
        if (values[0] === 4) {
          this.searchFormData.secondState = 4;
          this.searchFormData.firstState = null;
        }
        if (values[0] === 5) {
          this.searchFormData.firstState = 2;
          this.searchFormData.secondState = 2;
        }
      } else {
        this.searchFormData.firstState = null;
        this.searchFormData.secondState = null;
      }
      this.getSearchListKey()
    },
    async getCompSignUrl(id) {
      showLoading();
      let res = await $api.eleContract.post("getCompSignUrl", {
        id: id,
        returnUrl: process.env.VUE_APP_LOGIN + '/agreement/eleContract'
      });
      hideLoading();
      if (res.status === 1) {
        window.location.href = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    downloadEle(row) {
      window.open(row.downloadUrl);
    },
    downloadContract(row) {
      this.downLoad(row.docUrl);
    },
    async downLoad(url) {
      let name = url.substring(url.lastIndexOf("/") + 1)
      let responsePromise = await fetch(url)
      let blob = await responsePromise.blob()
      let objectURL = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = objectURL
      a.download = name
      a.click()
      a.remove()
    },
    viewContract(row) {
      this.detailModal = true;
      this.$refs.detailModal.init(row, 'pt');
    },
    closeModal() {
      this.$refs.eleModal.cancel();
    },
    close() {
      this.isShowModal = false;
      this.getSearchListKey();
    },
    showDialog() {
      window.open('/contracts/create');
    },
    reset() {
      this.searchFormData = {
        contractNum: null,
        contractName: null,
        contractTypeList: null,
        secondPartyPhone: null,
        secondPartyTime: null,
        carShipNum: null,
        goodsName: null,
        goodsBeginDate: null,
        createTime: null,
        state: null,
        beginPlace: null,
        endPlace: null
      };
      this.searchFirstPartyName = [];
      this.searchSecondPartyName = [];
      this.searchSalesMan = [];
      this.searchCreateUser = [];
    },
    resetEle() {
      this.searchFormDataEle = {
        contractNum: null,
        contractName: null,
        contractTypeList: null,
        partyPhone: null,
        partyTime: null,
        carShipNum: null,
        goodsName: null,
        beginDate: null,
        createTime: null,
        state: null,
        beginPlace: null,
        endPlace: null
      };
      this.searchSecondPartyNameEle = [];
      this.searchSalesManEle = [];
      this.searchCreateUserEle = [];
    },
    resetMatching() {
      this.searchSecondPartyNameMatching = [];
      this.searchFirstPartyNameMatching = [];
    },
    openRangeDate(field) {
      if (this.searchFormData[field] === 1) {
        this.rangeTime = field;
        this.open = true;
      } else {
        this.open = false;
      }
    },
    openRangeDateEle(field) {
      if (this.searchFormDataEle[field] === 1) {
        this.rangeTimeEle = field;
        this.openEle = true;
      } else {
        this.openEle = false;
      }
    },
    handleChangeEle(date) {
      this.timeValEle = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeValEle);
    },
    handleClearEle() {
    },
    handleOkEle() {
      this.searchFormDataEle[this.rangeTimeEle] = this.timeValEle;
      this.rangeTimeEle = false;
      let that = this;
      setTimeout(() => {
        that.searchVisibleEle = true;
      }, 100);
    },
    handleChange(date) {
      this.timeVal = date;
      // this.timeVal = date.map( v => moment(v).valueOf());
      console.log(this.timeVal);
    },
    handleClear() {
    },
    handleOk() {
      this.searchFormData[this.rangeTime] = this.timeVal;
      this.rangeTime = false;
      let that = this;
      setTimeout(() => {
        that.searchVisible = true;
      }, 100);
    },
    maxTagPlaceholder(num) {
      return "更多+ " + num;
    },
    remoteMethod(query, options, url, path, columnType) {
      if (query !== "") {
        this.searchLoading = true;
        this.getList(query, options, url, path, columnType);
      } else {
        this[options] = [];
      }
    },
    async getList(query, options, url, path, columnType) {
      let params = {
        columnType: columnType,
      };

      if (!isEmpty(query)) {
        params.keyword = query;
      }
      if (isEmpty(this[options])) {
        this.searchLoading = true;
      }
      let res = await $api[url].post(path, params);
      this.searchLoading = false;
      if (res.status === 1) {
        this[options] = res.data;
      }
    },
    setDefaultOptions(options, option) {
      this[option] = options;
    },
    refresh() {
      if (this.tabVal === 'ele') {
        this.getSearchListKeyEle()
      }
      if (this.tabVal === 'matching') {
        this.getSearchListKeyMatching();
      } else {
        this.getSearchListKey();
      }
    },
    async getContractFadadaTwoList(obj) {
      this.loading = true;
      let res = await $api.eleContract.request("getContractFadadaTwoList", obj);
      if (res.status === 1) {
        this.elePage.totalResult = res.data.total;
        this.eleData = res.data.rows;
        this.eleData.map((i) => {
          let partyNameStr = '';
          i.isMsg = true;
          if (i.ordContractFadadaExpands) {
            i.ordContractFadadaExpands.map(j => {
              partyNameStr = partyNameStr + j.partyName + ',';
              if (j.msgCount > 1) {
                i.isMsg = false;
              }
            });
          }
          i.partyNameStr = partyNameStr.slice(0, partyNameStr.length - 1);
          this.eleRecords.map((j) => {
            if (i.id === j.id) {
              this.$refs.eleTable.setCheckboxRow(i, true);
            }
          });
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getContractFadadaList(obj) {
      this.loading = true;
      obj.dataType = 2;
      let res = await $api.eleContract.request("getContractFadadaList", obj);
      if (res.status === 1) {
        this.page.totalResult = res.data.total;
        this.tableData = res.data.rows;
        this.tableData.map((i) => {
          this.records.map((j) => {
            if (i.id === j.id) {
              this.$refs.xTable.setCheckboxRow(i, true);
            }
          });
        });
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getMatchingContractFadadaList(obj) {
      this.loading = true;
      obj.dataType = 3;
      let res = await $api.eleContract.request("getContractFadadaList", obj);
      if (res.status === 1) {
        this.matchingPage.totalResult = res.data.total;
        this.matchingData = res.data.rows;
        this.loading = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    getSearchListKeyEle() {
      let obj = this.searchFormDataEle;
      let paramsObj = {};
      Object.keys(obj).forEach((key) => {
        if (
            obj[key] !== null &&
            key !== "createTime" &&
            key !== "beginDate" &&
            key !== "partyTime" &&
            obj[key] !== undefined
        ) {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd =
              moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["beginDate"] && obj["beginDate"].length > 0) {
          paramsObj.beginDateBegin = moment(obj.beginDate[0]).valueOf(); // 开始时间
          paramsObj.beginDateEnd = moment(obj.beginDate[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["partyTime"] && obj["partyTime"].length > 0) {
          paramsObj.partyTimeBegin = moment(obj.partyTime[0]).valueOf(); // 开始时间
          paramsObj.partyTimeEnd = moment(obj.partyTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["passTime"] && obj["passTime"].length > 0) {
          paramsObj.passTimeBegin = moment(obj.passTime[0]).valueOf(); // 开始时间
          paramsObj.passTimeEnd = moment(obj.passTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.elePage.pageSize;
      if (this.searchSecondPartyNameEle.length > 0) {
        paramsObj.partyNameList = this.searchSecondPartyNameEle;
      }
      if (this.searchSalesManEle.length > 0) {
        paramsObj.salesManIdList = this.searchSalesManEle;
      }
      if (this.searchCreateUserEle.length > 0) {
        paramsObj.createUserIdList = this.searchCreateUserEle;
      }

      if (paramsObj.contractTypeList) {
        if (typeof (paramsObj.contractTypeList) === 'number') {
          paramsObj.contractTypeList = [paramsObj.contractTypeList];
        } else {
          paramsObj.contractTypeList = paramsObj.contractTypeList.split('#');
        }
      }
      this.paramsObjEle = paramsObj;
      this.elePage.currentPage = 1;
      this.elePage.pageSize = 10;
      this.getContractFadadaTwoList(paramsObj);
      this.searchVisibleEle = false;
    },
    getSearchListKey() {
      let obj = this.searchFormData;
      let paramsObj = {};
      Object.keys(obj).forEach((key) => {
        if (
            obj[key] !== null &&
            key !== "createTime" &&
            key !== "goodsBeginDate" &&
            key !== "secondPartyTime" &&
            obj[key] !== undefined
        ) {
          paramsObj[key] = obj[key];
        }
        if (obj["createTime"] && obj["createTime"].length > 0) {
          paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
          paramsObj.createTimeEnd =
              moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["goodsBeginDate"] && obj["goodsBeginDate"].length > 0) {
          paramsObj.goodsBeginDateBegin = moment(obj.goodsBeginDate[0]).valueOf(); // 开始时间
          paramsObj.goodsBeginDateEnd = moment(obj.goodsBeginDate[1]).valueOf() + 86399999; // 结束时间
        }
        if (obj["secondPartyTime"] && obj["secondPartyTime"].length > 0) {
          paramsObj.secondPartyTimeBegin = moment(obj.secondPartyTime[0]).valueOf(); // 开始时间
          paramsObj.secondPartyTimeEnd = moment(obj.secondPartyTime[1]).valueOf() + 86399999; // 结束时间
        }
      });
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      if (this.searchFirstPartyName.length > 0) {
        paramsObj.firstPartyNameList = this.searchFirstPartyName;
      }
      if (this.searchSecondPartyName.length > 0) {
        paramsObj.secondPartyNameList = this.searchSecondPartyName;
      }
      if (this.searchSalesMan.length > 0) {
        paramsObj.salesManIdList = this.searchSalesMan;
      }
      if (this.searchCreateUser.length > 0) {
        paramsObj.createUserIdList = this.searchCreateUser;
      }
      if (paramsObj.contractTypeList) {
        if (typeof (paramsObj.contractTypeList) === 'number') {
          paramsObj.contractTypeList = [paramsObj.contractTypeList];
        } else {
          paramsObj.contractTypeList = paramsObj.contractTypeList.split('#');
        }
      }
      this.paramsObj = paramsObj;
      this.page.currentPage = 1;
      this.page.pageSize = 10;

      this.getContractFadadaList(paramsObj);
      this.searchVisible = false;
    },
    getSearchListKeyMatching(type) {
      let paramsObj = {};
      paramsObj.page = 1;
      paramsObj.rows = this.page.pageSize;
      paramsObj.fadadaState = type ? type : null;
      if (this.searchFirstPartyNameMatching.length > 0) {
        paramsObj.firstPartyNameList = this.searchFirstPartyNameMatching;
      }
      if (this.searchSecondPartyNameMatching.length > 0) {
        paramsObj.secondPartyNameList = this.searchSecondPartyNameMatching;
      }

      this.paramsMatchingObj = paramsObj;
      this.matchingPage.currentPage = 1;
      this.matchingPage.pageSize = 10;

      this.getMatchingContractFadadaList(paramsObj);
      this.searchVisibleMathing = false;
    },
    afterChange() {
      this.changeVisible = false;
      this.refresh();
    },
    changeType(row) {
      this.changeVisible = true;
      this.$nextTick(() => {
        this.$refs.changeType.init(row.id, row.contractType);
      })
    },
    commitCancel(id) {
      this.$XModal.confirm("您确定要撤回吗？").then((type) => {
        if (type === "confirm") {
          this.cancel(id);
        }
      });
    },
    commitDelete(id) {
      this.$XModal.confirm("您确定要删除吗？").then((type) => {
        if (type === "confirm") {
          this.delete(id);
        }
      });
    },
    async sendContractUrlMsg(id) {
      let res = await $api.eleContract.request("sendContractUrlMsg", {
        id: id,
      });
      if (res.status === 1) {
        this.$Message.success("催促成功");
        this.getSearchListKey();
        this.getSearchListKeyEle();
        this.getSearchListKeyMatching();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async cancel(id) {
      let res = await $api.eleContract.request("cancelContractFadada", {
        id: id,
      });
      if (res.status === 1) {
        this.$Message.success("撤回成功");
        this.getSearchListKey();
        this.getSearchListKeyEle();
        this.getSearchListKeyMatching();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async delete(id) {
      let res = await $api.eleContract.request("deleteContractFadada", {
        id: id,
      });
      if (res.status === 1) {
        this.$Message.success("删除成功");
        this.getSearchListKey();
        this.getSearchListKeyEle();
        this.getSearchListKeyMatching();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    changePage(e) {
      this.page.currentPage = e.currentPage;
      this.page.pageSize = e.pageSize;
      this.paramsObj.page = this.page.currentPage;
      this.paramsObj.rows = this.page.pageSize;
      this.getContractFadadaList(this.paramsObj);
    },
    changeMatchingPage(e) {
      this.matchingData.currentPage = e.currentPage;
      this.matchingData.pageSize = e.pageSize;
      this.paramsMatchingObj.page = this.matchingData.currentPage;
      this.paramsMatchingObj.rows = this.matchingData.pageSize;
      this.getMatchingContractFadadaList(this.paramsMatchingObj);
    },
    changePageEle(e) {
      this.elePage.currentPage = e.currentPage;
      this.elePage.pageSize = e.pageSize;
      this.paramsObjEle.page = this.elePage.currentPage;
      this.paramsObjEle.rows = this.elePage.pageSize;
      this.getContractFadadaTwoList(this.paramsObjEle);
    },
  },
};
</script>

<style scoped>
.btn-down {
  border: none;
}

.btn-down:focus {
  outline: none;
  border-color: transparent;
  box-shadow: none;
  background: transparent;
}

.page-con-header {
  margin-bottom: 10px;
  position: relative;
}

.btn-down.ivu-btn {
  background: transparent;
}

.btn-down.ivu-btn:hover {
  background: transparent;
}

.trackBox {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 100;
  background: #fff;
}

.proModal >>> .vxe-modal--box .vxe-modal--body {
  padding: 0;
  background: #F5F7F9;
}

.signDiv {
  display: flex;
  align-items: flex-start;
}

.signState {
  margin-right: 10px;
  width: 46px;
  height: 20px;
  background: #FFE8E8;
  border-radius: 4px;
  font-size: 12px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #FF0000;
  text-align: center;
  line-height: 20px;
}

.grey {
  background: #E8E8E8 !important;
  color: #333333 !important;
}

.line {
  margin: 18px 0;
  width: 100%;
  height: 1px;
  background: #E5E6EB;
}

.signContent {
  display: flex;
  flex-direction: column;
}
</style>
